import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container mx-auto mt-6" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Your account has been disabled. Please contact support.", -1)

import AlertCard from "@/components/AlertCard.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'AccountDisabled',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AlertCard, { type: "warning" }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    })
  ]))
}
}

})